import React from "react";
import DraggableList from "../../../../../yoello-lib/modules/components/draggable-list";

interface ISelectedItemsReOrderingList<T> {
    listItems: T[];
    fieldList: any[];
    listClassName: string;
    onSortedItem?: (product: string[]) => void;
    dataComponentName?: string;
}

export function SelectedItemsReOrderingList<T>({
    listItems,
    fieldList,
    listClassName,
    onSortedItem,
    dataComponentName
}: ISelectedItemsReOrderingList<T>) {
    if (listItems?.length > 0) {
        return <DraggableList
            nameFieldIndex={0}
            className={listClassName}
            list={listItems}
            fields={fieldList}
            id={'listItems-' + listClassName}
            onDrop={(data) => onSortedItem ? onSortedItem(data.map((item) => item.id)):null
            }
            dataComponentName={dataComponentName}

        />
    } 
    return null
}